import React, { useContext, useEffect, useState, useRef } from "react";
import "./CentralNotificacao.scss";
import useLoading from "@hooks/useLoading";
import GlobalContext from "@context/GlobalContext";
import { useNavigate } from "react-router-dom";
import usePermissoes from "@hooks/usePermissoes";
import IconNotificacao from "@icons/IconNotificacao";
import Switch from "@components/switch/Switch";
import Input from "@components/input/Input";
import UtilServices from "@services/UtilServices";
import EndPointServices from "@services/ApiServices";
import Calendario from "@components/calendario/Calendario";

const CentralNotificacao = () => {
  //State Padrões
  const [setLoading] = useLoading();
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();

  //Switch
  const [switchSelecionado, setSwitchSelecionado] = useState({
    key: "Situacao",
    button: "não lido",
  }); //Default
  const lstSwitch = [{ button: "não lido" }, { button: "lido" }];

  //Lista Fechada.
  const [listaFechada, setListaFechada] = useState([]); //Default

  //item selecionado
  const [itemSelecionado, setItemSelecionado] = useState({});

  //item pesquisa
  const [pesquisa, setPesquisa] = useState("");

  //Date
  const [selectedDate, setSelectedDate] = useState(null);

  //useeffect
  useEffect(() => {
    handleConsultaNotificacao();
  }, []);

  //Seleciona 1 item.
  useEffect(() => {
    if (itemSelecionado?.conteudo) {
      try {
        let jsonText = document.querySelector("pre").textContent;

        // Tenta parsear o texto para garantir que o JSON é válido
        try {
          const jsonObj = JSON.parse(jsonText);

          // Se a função colorizeJson for responsável por transformar o JSON em HTML colorido, use-a aqui.
          const coloredJson = UtilServices.colorizeJson(jsonObj);

          // Atualiza o conteúdo com o JSON colorido
          document.querySelector("pre").innerHTML = coloredJson;
        } catch (e) {
          console.error("Erro ao fazer parse do JSON: ", e);
        }
      } catch (error) {
        console.error("Erro ao processar o JSON:", error);
      }
    }
    if (
      itemSelecionado?.lido !== true &&
      Object.keys(itemSelecionado).length > 0
    ) {
      handleAdicionarNotificacao();
      handleAtualizarListaFechada();

      //Seta a notificacao.
      UtilServices.setStorage("notificacao", state.notificacao - 1);
      dispatch({
        type: "SET_NOTIFICACAO",
        payload: state.notificacao - 1,
      });
    }
  }, [itemSelecionado]);

  //Switch
  useEffect(() => {
    handleConsultaNotificacao();
  }, [switchSelecionado]);

  //Pesquisa
  useEffect(() => {
    const timeout = setTimeout(() => {
      handleConsultaNotificacao(pesquisa);
    }, 1000); // Aguarda 500ms antes de pesquisar

    return () => clearTimeout(timeout); // Limpa o timeout se o usuário digitar novamente
  }, [pesquisa]);

  //Data Pesquisa
  useEffect(() => {
    handleConsultaNotificacao();
  }, [selectedDate]);

  async function handleConsultaNotificacao(e) {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      lido: switchSelecionado.button === "não lido" ? 0 : 1,
      busca: e,
      data: selectedDate?.toLocaleDateString(),
    };

    try {
      var retornoapi = await EndPointServices.ALT_ConsultaNotificacao(data);
      if (retornoapi.Success) {
        setListaFechada(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }
  async function handleAdicionarNotificacao() {
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      ID_Log: itemSelecionado?.ID_Log,
    };

    try {
      var retornoapi = await EndPointServices.ALT_AdicionarNotificacao(data);
    } catch (ex) {
      console.log(ex);
    }
  }
  function handleAtualizarListaFechada() {
    setListaFechada((prevLista) =>
      prevLista.map((item) =>
        item.ID_Log === itemSelecionado.ID_Log ? { ...item, lido: true } : item,
      ),
    );
  }

  return (
    <div className="centralnotificacao row">
      <div className="caixa-mensagens col-4">
        <div className="qtd-mensagens">
          <IconNotificacao />
          <p>{state.notificacao} Mensagens não lidas</p>
        </div>
        <Switch
          lstSwitch={lstSwitch}
          setRetorno={(e) =>
            setSwitchSelecionado({ key: "Situacao", button: e.button })
          }
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Input
            theme="2"
            icon="<i class='fa-light fa-magnifying-glass'></i>"
            value={pesquisa}
            onChange={(e) => {
              setPesquisa(e);
            }}
          />
          <div className="select-calendario">
            <Calendario
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
          </div>
        </div>
        <div className="total">Total: {listaFechada.length}</div>
        <div className="lista-fechada">
          {listaFechada.map((item, index) => (
            <div
              key={item.id || `fallback-key-${index}`} // Garante chave única
              className={`item-lista-fechada ${!item.lido ? "lido" : ""}`}
              onClick={() => {
                setItemSelecionado(item);
              }}
            >
              <div className="titulo">
                <p>{UtilServices.primeiraLetraMaiuscula(item.assunto)}</p>
                <p>{item.data}</p>
              </div>
              <p className="conteudo">{item.conteudo}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mensagens-aberta col-8">
        <p className="assunto-aberto">
          {UtilServices.primeiraLetraMaiuscula(itemSelecionado.assunto)}
        </p>
        <p className="data-aberto">{itemSelecionado.dataCompleta}</p>
        <p className="conteudo-aberto">
          {UtilServices.stringToJsx(itemSelecionado.conteudo)}
        </p>
      </div>
    </div>
  );
};

export default CentralNotificacao;
